import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AspInvoicesDetailsComponent } from '../asp-invoices-details/asp-invoices-details.component';

const routes: Routes = [
  {
    path: 'invoice/:encoded', 
    component: AspInvoicesDetailsComponent
   
  },
];
@NgModule({
  declarations: [AspInvoicesDetailsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    HttpClientModule
  ],
  exports: [AspInvoicesDetailsComponent, RouterModule],
})
export class AspInvoicesDetailsModule { }
